exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-row[data-v-1f6cd92a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:rows;flex-direction:rows}.el-row [class^=el-col]>div[data-v-1f6cd92a]{height:100%}.secondary[data-v-1f6cd92a]{padding:2rem 0;color:#666;text-align:center}.delivery-contact .name[data-v-1f6cd92a]{font-weight:600}.delivery-address[data-v-1f6cd92a]{font-size:.9em;margin-top:.5rem}.no-notes[data-v-1f6cd92a]{font-style:italic;color:#999}.already-ordered[data-v-1f6cd92a]{color:#999;font-size:.9em;text-align:center;padding:2rem 0}.already-ordered .el-button[data-v-1f6cd92a]{margin-top:1rem}.classic[data-v-1f6cd92a]{white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f6cd92a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/blocks/Request.vue
// module id = 488
// module chunks = 0